<template>
    <div class="languageSelect" >
        <v-select
          :items="languages"
          v-model="$i18n.locale"
          flat
          dense
          solo
          background-color="#3A3A3A"
          color="#DADADA"
          item-color="none"
          @change="changeLocalization"
          >
          <template v-slot:selection="{ item }" >
            <div class="abbr">{{item.abbr}}</div>
          </template>
        </v-select>
    </div>
</template>
<script>
import Cookie from 'vue-cookie'

export default {
  name: 'localeChangerToolbar',
  data: () => ({
    languages: [
      { text: 'Українська', abbr: 'Укр', value: 'uk' },
      { text: 'English', abbr: 'Eng', value: 'en' }
    ]
  }),
  methods: {
    changeLocalization(item) {
      Cookie.set('locale', item)
      this.$store.dispatch('loadLocalization', item)
      window.location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
.languageSelect {
  max-width: 75px;
  margin-top: 30px;
}
.abbr {
  color:#F2F2F2;

}

</style>
